import { MantineColor } from '@mantine/core';

const LEGACY_INTENT_COLORS: Record<string, MantineColor> = {
  none: 'gray',
  primary: 'blue',
  success: 'green',
  warning: 'yellow',
  danger: 'red',
};

/** Workflow button colours are persisted per step and may still hold legacy Blueprint intent names from pre-Mantine records; anything else is already a Mantine/CSS colour and passes through. */
export const resolveWorkflowButtonColor = (
  value: string | null | undefined,
): MantineColor | undefined =>
  value ? LEGACY_INTENT_COLORS[value.toLowerCase()] ?? value : undefined;
